var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_4",
    "data-name": "Artboard \\u2013 4",
    clipPath: "url(#clip-Artboard_4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_16px_white_laptop",
    "data-name": "Icons/16px/white/laptop",
    transform: "translate(5.063 7.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_16px_primary_laptop",
    "data-name": "icons/16px/primary/laptop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laptop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0,0H10.874",
    transform: "translate(0 8.45)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    width: 7.974,
    height: 6.145,
    transform: "translate(1.45)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.6247adac032643f7bfe4c29087197382.svg";
export { ForwardRef as ReactComponent };